import React, { useState } from "react";
import "../Shippers/ShippersList/shipperslist.css";

// components imports
import ShippersTable from "../../../../../Components/BoltTable/BoltTable";
import InvoicesHistory from "../InvoicesHistory/InvoicesHistory";
import PaymentsHistory from "../PaymentsHistory/PaymentsHistory";
import Confirm from "../../../../../Components/Popups/Confirm";
import Tooltip from "../../../../../Components/Tooltip/Tooltip";
import SwitchButton from "../../../../../Components/SwitchButton/SwitchButton";
// apis imports
import {
  fetchUsers,
  updateServicecharge,
  updateAccountStatus,
  deleteUserByAdmin,
} from "../../../../../services/AdminServices/Users/users.services";
// library imports
import { IoInformationCircleOutline } from "react-icons/io5";
import { IconButton } from "@mui/material";
import CustomMenu from "../Shippers/Components/ActionsDropDown/ActionsDropDown";
import { convertTime } from "../../../../../helpers/helpers";
import AdminControls from "../../../AdminControls/AdminControls";
import { useTranslation } from "react-i18next";

const OneTimeShipperList = ({ setSnack }) => {
  const { t } = useTranslation("admin");
  const [oneTimeShippers, setOneTimeShippers] = useState([]);
  const [Change, setChange] = useState(false);
  const [invoicesHistoryModal, setInvoicesHistoryModal] = useState(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState();
  const [statusUpdating, setStatusUpdating] = useState();
  const [adminControlsModal, setAdminControlsModal] = useState(false);

  const fetchAllOneTimeShippers = async (page, perPage, filter) => {
    const response = await fetchUsers(page, perPage, filter, "oneTimeShipper");
    if (!response.error) {
      setOneTimeShippers(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: t("users.userNameColumn"),
      render: (row) => <>{row?.username ?? "-"}</>,
      width: "200px",
    },
    {
      id: 2,
      label: t("users.businessName"),
      render: (row) => <>{row?.business_name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("users.email"),
      render: (row) => <>{row?.email ?? "-"}</>,
      width: "200px",
    },
    {
      id: 4,
      label: t("users.website"),
      render: (row) => (
        <>
          {row?.website ? (
            <a
              href={
                row?.website.startsWith("http")
                  ? row?.website
                  : `http://${row?.website}`
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {row?.website}
            </a>
          ) : (
            "N/A"
          )}
        </>
      ),
      width: "200px",
    },
    {
      id: 5,
      label: t("users.markup"),
      render: (row) => (
        <>
          {row?.markup_formula?.formula_details?.[0]?.value
            ? `${row.markup_formula.formula_details[0].value} %`
            : t("users.default")}
        </>
      ),
      width: "200px",
    },
    {
      id: 6,
      label: t("users.balance"),
      render: (row) => <>{row?.balance ?? "-"}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("users.shipmentCount"),
      render: (row) => <>{row?.shipments_count ?? "0"}</>,
      width: "200px",
    },
    {
      id: 8,
      label: (
        <>
          {t("users.activate")}
          <Tooltip title={t("users.accountApprovedDisapproved")}>
            <IconButton>
              <IoInformationCircleOutline size={10} />
            </IconButton>
          </Tooltip>
        </>
      ),
      render: (row) => (
        <>
          <SwitchButton
            onChange={(e) => handleStatusChange(e, row)}
            checked={
              ![false, "false", "0", null, undefined].includes(
                row.account_status
              )
            }
            disabled={Change === "Status" ? true : false}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 9,
      label: (
        <>
          {t("users.serviceCharge")}
          <Tooltip title={t("users.billingActivatedDeactivated")}>
            <IconButton>
              <IoInformationCircleOutline size={10} />
            </IconButton>
          </Tooltip>
        </>
      ),
      render: (row) => (
        <>
          <SwitchButton
            onChange={(e) => handleServiceCharge(e, row)}
            checked={
              ![false, "false", "0", null, undefined].includes(
                row?.is_service_charge
              )
            }
            disabled={Change === "Service" ? true : false}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 10,
      label: t("users.registeredAt"),
      render: (row) => <>{convertTime(row?.created_at)}</>,
      width: "200px",
    },
    {
      id: 11,
      label: t("users.adminActions"),
      render: (row) => (
        <CustomMenu
          row={row}
          setInvoicesHistoryModal={setInvoicesHistoryModal}
          setHistoryModal={setHistoryModal}
          setConfirmDelete={setConfirmDelete}
          setAdminControlsModal={setAdminControlsModal}
        />
      ),
      width: "600px",
      fixed: "right",
    },
  ];

  const handleServiceCharge = async (e, record) => {
    setChange("Service");
    const updated = await updateServicecharge({
      id: parseInt(record.id),
      is_service_charge: e.target.checked,
    });

    if (updated.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: updated.error.message,
          severity: "error",
        };
      });
      setChange(false);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: ![false, "false", "0", null, undefined].includes(
            updated?.data?.result?.is_service_charge
          )
            ? t("users.billingActive", { name: updated?.data?.result?.username ?? t("users.userFallback") })
            : t("users.billingInactive", { name: updated?.data?.result?.username ?? t("users.userFallback") }),
          severity: ![false, "false", "0", null, undefined].includes(
            updated?.data?.result?.is_service_charge
          )
            ? "success"
            : "info",
        };
      });
      setOneTimeShippers((prevOneTimeShippers) => {
        return {
          ...prevOneTimeShippers,
          data: prevOneTimeShippers?.data.map((item) =>
            item.id === record.id
              ? {
                  ...item,
                  is_service_charge: ![
                    false,
                    "false",
                    "0",
                    null,
                    undefined,
                  ].includes(updated?.data?.result?.is_service_charge),
                }
              : item
          ),
        };
      });
      setChange(false);
    }
  };

  const handleStatusChange = async (e, record) => {
    setChange("Status");
    const updated = await updateAccountStatus({
      id: parseInt(record.id),
      account_status: e.target.checked,
    });

    if (updated.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: updated.error.message,
          severity: "error",
        };
      });
      setChange(false);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: ![false, "false", "0", null, undefined].includes(
            updated?.data?.result?.account_status
          )
            ? t("users.statusActive", { name: updated?.data?.result?.username ?? t("users.userFallback") })
            : t("users.statusInactive", { name: updated?.data?.result?.username ?? t("users.userFallback") }),
          severity: ![false, "false", "0", null, undefined].includes(
            updated?.data?.result?.account_status
          )
            ? "success"
            : "info",
        };
      });
      setOneTimeShippers((prevOneTimeShippers) => {
        return {
          ...prevOneTimeShippers,
          data: prevOneTimeShippers?.data.map((item) =>
            item.id === record.id
              ? {
                  ...item,
                  account_status: ![
                    false,
                    "false",
                    "0",
                    null,
                    undefined,
                  ].includes(updated?.data?.result?.account_status),
                }
              : item
          ),
        };
      });
      setChange(false);
    }
  };

  const updateOneTimeShipper = (id, column, value) => {
    setOneTimeShippers((prevOneTimeShippers) => ({
      ...prevOneTimeShippers,
      data: prevOneTimeShippers?.data.map((item) => {
        if (item.id !== id) return item;

        // ✅ Support both single and multiple column updates
        if (typeof column === "object" && column !== null) {
          return { ...item, ...column }; // merge only provided keys
        }

        return { ...item, [column]: value };
      }),
    }));

    if (adminControlsModal && adminControlsModal.id === id) {
      setAdminControlsModal((prev) => {
        if (typeof column === "object" && column !== null) {
          return { ...prev, ...column };
        }
        return { ...prev, [column]: value };
      });
    }
  };

  const handleDeleteUser = async (record) => {
    setStatusUpdating(true);
    const response = await deleteUserByAdmin(record.id);

    if (response.error) {
      setStatusUpdating(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    } else {
      setOneTimeShippers((prevOneTimeShippers) => {
        return {
          ...prevOneTimeShippers,
          data: prevOneTimeShippers?.data.filter(
            (item) => item.id !== record.id
          ),
        };
      });

      setStatusUpdating(false);
      setConfirmDelete(false);
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("users.userDeletedSuccessfully"),
          severity: "success",
        };
      });
    }
  };

  return (
    <div>
      <InvoicesHistory
        open={invoicesHistoryModal}
        setOpen={setInvoicesHistoryModal}
        User={invoicesHistoryModal}
        setSnack={setSnack}
      />
      <PaymentsHistory
        open={historyModal}
        setOpen={setHistoryModal}
        setSnack={setSnack}
        User={historyModal}
      />
      <Confirm
        open={confirmDelete}
        setOpen={setConfirmDelete}
        handleConfirm={() => handleDeleteUser(confirmDelete)}
        text={t("users.doYouWantToDelete")}
        loader={statusUpdating}
      />
      <AdminControls
        open={!!adminControlsModal}
        setOpen={setAdminControlsModal}
        shipperData={adminControlsModal}
        updateShipper={updateOneTimeShipper}
      />
      <div>
        <div className="actionbtn__needtobe_fixwidth">
          <ShippersTable
            tableTitle={t("users.oneTimeShippers")}
            tableId="OneTimeShipperTableForAdmin"
            message={t("users.noOneTimeShippersAvailable")}
            searchPlaceHolder={t("users.searchOneTimeShippers")}
            columns={columns}
            data={oneTimeShippers}
            getAllData={fetchAllOneTimeShippers}
          />
        </div>
      </div>
    </div>
  );
};

export default OneTimeShipperList;
